import { Component } from '@angular/core';

@Component({
    selector: 'app-registration-closed',
    templateUrl: './registration-closed.component.html',
    styleUrls: ['./registration-closed.component.scss']
})
export class RegistrationClosedComponent {
    registrationOpenDate = 'January 26th, 2026';
}